export default __webpack_public_path__ + "static/media/img_baseCotton_cotton.58c6d322.jpg";